/**
 * API Configuration for Khazenly Storage Service
 * 
 * This module contains API configuration settings including
 * base URL, headers, and common request configurations.
 */

const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_BACKEND_URL || 'https://khazenly.isnc-logistics.com',
  TIMEOUT: 10000,
  HEADERS: {
    'Content-Type': 'application/json',
  }
};

export const getAuthHeaders = (token) => ({
  ...API_CONFIG.HEADERS,
  'Authorization': `Bearer ${token}`
});

export const getFormHeaders = (token) => ({
  'Authorization': `Bearer ${token}`
});

export default API_CONFIG;
